import i18n from 'common/locales';
import { EMAIL_WHITELIST_ERR } from 'common/constants/Constants';

export const LOGIN_ERROR_MSG = {
  get E0010007() { return i18n.t('密码不正确，请重新输入'); },
  get E0010028() { return i18n.t('验证码不正确，请重新输入'); },
  get E0010035() { return i18n.t('切换失败！人员状态不可用'); },
  get E0010036() { return i18n.t('账号未绑定企业，登录失败！'); },
  get E0010019() { return i18n.t('切换失败！人员状态不可用'); },
  get E0010006() { return i18n.t('切换失败！当前租户不可用'); },
  get E0010061() { return i18n.t('该手机号已经被绑定，请直接使用该手机号登录或更换绑定的手机号。'); },
  get E0010161() { return i18n.t('今日验证码发送达到限制'); },
  [EMAIL_WHITELIST_ERR.code]: EMAIL_WHITELIST_ERR.msg,
};

export enum VERIFY_TYPE {
  CODE,
  PWD,
}
